export const APP_NAME = 'ADP Oracle Reconcile';
export const APP_VERSION = '1.0.0';
export const APP_PUBLIC_URL = 'https://reconcile.slpmicrosystems.com/';
export const APP_TAGLINE =
  'Catch Oracle Fusion HCM ↔ ADP GlobalView payroll mismatches before you close.';

export const TRADEMARK_DISCLAIMER =
  'ADP, GlobalView, and related marks are trademarks of ADP, Inc. Oracle, Oracle Fusion, and Oracle Cloud are trademarks of Oracle Corporation. This application is an independent reconciliation tool and is not affiliated with, endorsed by, or a product of ADP or Oracle.';

export const PRODUCT_PITCH =
  'A specialist payroll-validation workbench for OGPI implementations: compare Oracle element entries to the ADP register, run pre-close checks, and export exceptions your team can fix before pay confirmation.';
